import { Theme } from "../../../../../components/constants";

export default {
    boxInputFieldContainer: {
        display: "flex",
        flexDirection: "column",
        minWidth: "250px",
        maxWidth: "300px",
        flex: "1 1 0%",
        marginLeft: "3px",
    },
    grayBorder: {
        borderBottom: "0.5px solid #E2E4EB",
        width: "100%",
        margin: "20px 0px"
    },
    boxInputFieldLabel: {
        fontWeight: "400",
        fontSize: "16px",
        lineHeight: "20px",
        color: Theme.DISABLED_TEXT,
    },
    addEditIntermediaryButtonsDiv: {
        display: "flex",
        flexDirection: "row",
        gap: "10px",
        marginTop: '10px',
    },
    parentFieldDiv: {
        display: "flex",
        flex: 1,
    },
    groupContainer: {
        marginBottom: "10px",
        padding: "5px",
        border: "1px solid #ccc",
        display: "flex",
        flexDirection: "row",
        flexWrap: "wrap",
    },
    groupFieldFullWidth: {
        flex: "1 0 100%",
    },
    groupFieldsLabel: {
        fontWeight: "400",
        fontSize: "16px",
        lineHeight: "20px",
        color: Theme.DISABLED_TEXT,
        // width: "100%",
        flex: "100%",
    },
    requiredStarLabel: {
        color: Theme.ERROR_TEXT,
    },
}